import { render, staticRenderFns } from "./PickUp.vue?vue&type=template&id=b5713944"
import script from "./PickUp.vue?vue&type=script&lang=js"
export * from "./PickUp.vue?vue&type=script&lang=js"
import style0 from "./PickUp.vue?vue&type=style&index=0&id=b5713944&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b5713944')) {
      api.createRecord('b5713944', component.options)
    } else {
      api.reload('b5713944', component.options)
    }
    module.hot.accept("./PickUp.vue?vue&type=template&id=b5713944", function () {
      api.rerender('b5713944', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/preview/PickUp.vue"
export default component.exports